<template>
  <div id="app">
    <div style="padding: 5px 10px; float:left">
      <el-button @click="employeeOp">{{ employeeOpBtn }}</el-button>
      <!-- 隐藏已完成的 -->
      <el-button @click="progressOp">{{ progressOpBtn }}</el-button>
    </div>
    <org-chart :datasource="orgChartData" @node-click="selectNode" :zoom="true" :pan="true" :panning="true"
      @tooltip-click="tooltipClick">
    </org-chart>
    <!-- <el-drawer title="" :visible.sync="drawer" :direction="direction" size="90%">
      <iframe
        v-if="drawer"
        :src="targetUrl"
        frameborder="0"
        style="width: 100%; height: 100%; min-height: 500px"
        referrerpolicy="no-referrer"
      ></iframe>
    </el-drawer> -->
  </div>
</template>

<script>
import OrgChart from "./components/OrganizationChartContainer.vue";
import request from "@/utils/request";

export default {
  name: "app",
  components: {
    OrgChart,
  },
  data() {
    return {
      // 数据源
      ds: {},
      // 组织chart数据
      orgChartData: {},
      drawer: false,
      direction: "btt",
      targetUrl: "",
      employeeOpBtn: "隐藏员工",
      employeeIsShow: true,
      progressOpBtn: "隐藏已完成",
      progressIsShowAll: true
    };
  },
  mounted() {
    this.getOkrs();
  },
  methods: {
    selectNode(nodeData) {
      // alert("node " + nodeData.name + " is selected");
      // https://www.fastcoy.com/team/app/5dd3ab4e1ec6d27b7787acb0/entry/5610ceac7613d2e5d3cb06b5/data/5ab6120123a76ec962126344
    },
    tooltipClick(oData) {
      // alert(`https://www.fastcoy.com/team/app/5dd3ab4e1ec6d27b7787acb0/entry/5610ceac7613d2e5d3cb06b5/data/${oData.dataId}`);
      const url = `https://www.fastcoy.com/team/app/5dd3ab4e1ec6d27b7787acb0/entry/5610ceac7613d2e5d3cb06b5/data/${oData.dataId}`;
      window.location.href = url;
      // this.drawer = true;
      // this.targetUrl = url;
    },
    async getOkrs() {
      const res = await request({
        url: "/okrs",
        method: "get",
      });
      this.ds = res;
      this.orgChartData = res;
    },
    // 员工数据显示和隐藏按钮的点击事件
    employeeOp() {
      // this.orgChartData = this.filterEmployeeNodes(this.ds, this.employeeIsShow);
      this.employeeIsShow = !this.employeeIsShow;

      this.getOrgData();

      if (this.employeeIsShow) {
        this.employeeOpBtn = "隐藏员工";
      } else {
        this.employeeOpBtn = "显示员工";
      }
    },
    /**
     * 递归过滤树结构中的员工节点
     * @param {Object|Array} node - 当前节点或节点数组
     * @param {boolean} showEmployees - 是否显示员工
     * @returns {Object|Array|null} 过滤后的新结构（员工被移除时返回 null）
     */
    filterEmployeeNodes(node, showEmployees) {
      // 如果是数组，递归处理每个元素
      if (Array.isArray(node)) {
        return node
          .map((item) => this.filterEmployeeNodes(item, showEmployees))
          .filter(Boolean); // 移除 null（即被隐藏的员工）
      }

      // 如果是对象（节点）
      if (node && typeof node === "object") {
        // 如果是员工且不显示，则跳过（返回 null）
        if (node.type === "employee" && !showEmployees) {
          return null;
        }

        // 复制当前节点（避免修改原数据）
        const newNode = { ...node };

        // 递归处理 children（如果存在）
        if (Array.isArray(node.children)) {
          newNode.children = this.filterEmployeeNodes(node.children, showEmployees);
        }

        return newNode;
      }

      return node;
    },

    /**
     * 隐藏已完成按钮操作
     */
    progressOp() {
      this.progressIsShowAll = !this.progressIsShowAll;

      this.getOrgData();

      if (this.progressIsShowAll) {
        this.progressOpBtn = "隐藏已完成";
      } else {
        this.progressOpBtn = "显示全部";
      }
    },
    /**
     * 过滤已完成的数据
     * @param data 
     */
    filterOutCompleted(data) {
      // 深拷贝当前节点（避免修改原始数据）
      const node = { ...data };

      // 如果有 content，过滤掉 progress === 100 的项
      if (Array.isArray(node.content)) {
        node.content = node.content.filter(item => item.progress !== 100);
      }

      // 如果有 children，递归处理每个子节点
      if (Array.isArray(node.children)) {
        node.children = node.children.map(child => this.filterOutCompleted(child));
      }

      return node;
    },
    /**
     * 处理组织数据
     */
    getOrgData() {
      let result = this.copyData(this.ds);
      if (this.progressIsShowAll) {
        if (this.employeeIsShow) {
          // 显示员工并且显示所有的进度，就是等于源数据
          result = this.copyData(this.ds);
        } else {
          // 不显示员工就过滤员工
          result = this.filterEmployeeNodes(this.copyData(this.ds), this.employeeIsShow);
        }
      } else {
        // 不显示已完成的，则先过滤
        let data = this.copyData(this.ds);
        result = this.filterOutCompleted(data);

        if (!this.employeeIsShow) {
          result = this.filterEmployeeNodes(this.copyData(result), this.employeeIsShow);
        }
      }
      this.orgChartData = result;
    },
    /**
   * 复制数据
   * @param data 
   */
    copyData(data) {
      return JSON.parse(JSON.stringify(data));
    }
  },

};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
